import { errorAlert } from '../helpers/SweetAlert';
import axios from 'axios';
import { errorsMessage } from '../helpers/Errors';

const API_BACKEND = process.env.REACT_APP_API;

export class ApiRest {
  #axiosBase;

  constructor(
    headers = {},
    baseUrl = API_BACKEND,
    contentType = 'application/json',
    ) {
        this.#axiosBase = axios.create({
            baseURL: baseUrl,
            headers: {
                ...headers,
                contentType
            },
        });
    }
    
  async post({ url, body }) {
    try {
      const res = await this.#axiosBase.post(url, body);
      const { response } = res.data;
      return response || res.data;
    } catch (err) {
      return this.handleError(err?.response?.status || 1, err?.response);
    }
  }

  async put({ url, body }) {
    try {
      const res = await this.#axiosBase.put(url, body);
      const { response } = res.data;
      return response;
    } catch (err) {
      return this.handleError(err?.response?.status || 1, err?.response);
    }
  }

  async get({ url, params = {} }) {
    try {
      const res = await this.#axiosBase.get(url, params);
      const { response } = res.data;
      return response;
    } catch (err) {
      return this.handleError(err?.response?.status || 1, err?.response);
    }
  }

  async patch({ url, params = {} }) {
    try {
      const res = await this.#axiosBase.patch(url, params);
      const { response } = res.data;
      return response;
    } catch (err) {
      return this.handleError(err?.response?.status || 1, err?.response);
    }
  }

  async delete({ url, params = {} }) {
    try {
      const res = await this.#axiosBase.delete(url, params);
      const { response } = res.data;
      return response;
    } catch (err) {
      return this.handleError(err?.response?.status || 1, err?.response);
    }
  }

  handleMessage(message, error_code) {
    if (error_code) {
      return errorsMessage[error_code];
    }
    if (message) {
      return message;
    }
    return '¡Por favor valida la información e intenta nuevamente!.';
  }

  handleError(status, res) {
    const response = res?.data?.response;
    const error_code = res?.data?.error_code;
    switch (status) {
      case 201:
      case 200:
        break;
      case 400:
        throw {
          status,
          message: this.handleMessage(response?.message, error_code),
        };
      case 401:
      case 1:
        errorAlert(
          'Error',
          status === 1
            ? '¡Disculpe ha ocurrido un error inesperado, por favor intente mas tarde!.'
            : '¡Tu sesión ha caducado, Inicia sesión nuevamente!.',
          () => {
            // localStorage.clear();
            // window.location.replace('/');
          },
        );
        // setTimeout(() => {
        //   localStorage.clear();
        //   window.location.replace('/');
        // }, 3 * 1000);
        throw {
          status,
        };
      case 404:
      case 504:
      case 503:
      case 502:
      case 501:
      case 500:
        errorAlert(
          '',
          '¡Disculpe ha ocurrido un error inesperado, por favor intente mas tarde!.',
        );
        break;
      default:
        break;
    }
  }
}
